// Fix: Interceptar clicks en el ícono del carrito para usar Rebuy Smart Cart.
// El tema (Stiletto) escucha [data-js-cart-icon] en bubble phase y abre su
// quick cart nativo, lo que entra en conflicto con Rebuy Smart Cart.
// Usamos capture phase en document para correr ANTES que cualquier handler
// del tema y redirigir a Rebuy.SmartCart.show().
(function () {
  document.addEventListener('click', function (e) {
    var cartIconEl = e.target.closest('[data-js-cart-icon]');
    if (!cartIconEl) return;

    e.preventDefault();
    e.stopPropagation(); // evita que el handler bubble del tema abra el quick cart nativo

    if (window.Rebuy && window.Rebuy.SmartCart) {
      window.Rebuy.SmartCart.show();
    }
    // Si Rebuy aún no cargó, no hacemos nada (raro, pero seguro)
  }, true); // true = capture phase, corre antes de los handlers en elementos
})();

document.addEventListener('DOMContentLoaded', function () {
  const stickyATC = document.getElementById('sticky-atc');
  const stickyButton = document.getElementById('sticky-atc-button');
  const priceEl = document.getElementById('sticky-atc-price');

  const productForm = document.querySelector('form[action^="/cart/add"]');
  if (!productForm) return;

  const variantInput = productForm.querySelector('input[name="id"]');

  /* =========================
     SHOW / HIDE STICKY
  ========================= */
  window.addEventListener('scroll', () => {
    stickyATC.classList.toggle('hidden', window.scrollY <= 400);
  });

  /* =========================
     VARIANT CHANGE (EVENT)
  ========================= */
  document.addEventListener('variant:change', function (event) {
    if (event.detail?.variant) {
      updateSticky(event.detail.variant);
    }
  });

  /* =========================
     FALLBACK (NO EVENTS)
  ========================= */
  productForm.addEventListener('change', () => {
    if (!variantInput?.value) return;

    const variant = window.ShopifyAnalytics?.meta?.product?.variants.find(
      v => String(v.id) === String(variantInput.value)
    );

    if (variant) updateSticky(variant);
  });

  /* =========================
     STICKY BUTTON → REAL BUTTON
     (THE ONLY IMPORTANT PART)
  ========================= */
  stickyButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (stickyButton.disabled) return;

    const realAddToCartBtn = document.getElementById('add-to-cart');
    if (realAddToCartBtn) {
      realAddToCartBtn.click();
    }
  });

  /* =========================
     UPDATE UI
  ========================= */
  function updateSticky(variant) {
    priceEl.innerHTML = Shopify.formatMoney(
      variant.price,
      "{{ shop.money_format }}"
    );

    stickyButton.disabled = !variant.available;
  }
});

    document.addEventListener('click', function (e) {
    if (e.target.classList.contains('custom-chip')) {
      e.target.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  });
